// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import { PreviouslyPurchasedFiltersComponent } from "@pace/App/Widgets/PreviouslyPurchased/PreviouslyPurchasedFilters";
import { customXngageWidget } from "@pace/XDL/constants";
import React, { useState } from "react";

type Props = WidgetProps;

export interface PreviouslyPurchasedHeaderStyles {
    container?: GridContainerProps;
    toggleFilterGridItem?: GridItemProps;
    toggleFilterIcon?: IconProps;
    toggleFilterButton?: ButtonPresentationProps;
    toggleFilterButtonIcon?: ButtonIconPresentationProps;
}

export const headerStyles: PreviouslyPurchasedHeaderStyles = {};

const styles = headerStyles;

const PreviouslyPurchasedHeader = ({ id }: Props) => {
    const [isFiltersOpened, setIsFiltersOpened] = useState(false);
    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.toggleFilterGridItem}>
                    <Button
                        {...styles.toggleFilterButton}
                        data-test-selector="previouslyPurchased_toggleFilter"
                        onClick={() => setIsFiltersOpened(!isFiltersOpened)}
                        aria-label="Toggle Filter"
                    >
                        <ButtonIcon {...styles.toggleFilterButtonIcon} src={isFiltersOpened ? Minus : Plus} />
                    </Button>
                </GridItem>
            </GridContainer>
            <StyledWrapper>
                <PreviouslyPurchasedFiltersComponent isFiltersOpened={isFiltersOpened} />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: PreviouslyPurchasedHeader,
    definition: {
        group: customXngageWidget as any,
        displayName: "Previously Purchased Header",
        allowedContexts: ["PreviouslyPurchasedPage"],
        isSystem: true,
    },
};

export default widgetModule;
